module.exports = __webpack_public_path__ + "static/13-ab3888e000b56e08ae7a7f417bb646ea.jpg";